export const macroProjectsList = [
  {
    title: "TechTribe",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1752164574/mp_29.png",
    date: "9 July, 2025",
    techStack: "NextJs, Typescript, MUIv5, ReduxToolkit, SocketIO, MongoDB, ExpressJS, NodeJS, AWS, Resend",
    description:
      "A full stack web application hosted AWS EC2 instance. Uses mongodb atlas to store it's clusters with aws as a provider.",
    preview: "https://thetechtribe.in/",
    code: "https://github.com/Namrata-J/TechTribe_Frontend, https://github.com/Namrata-J/TechTribe_Backend",
    hasMicroservices: true
  },
  {
    title: "Relievo",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1667756070/mp/mp_27.png",
    date: "Oct 31, 2022",
    techStack: "ReactJS, MaterialUI, ReactRouter",
    description:
      "A Dynamic Component Library which relieves developer's pain related to component UI Building!! An MVP build in just 40 hours as a part of roc8's Moonshot hackathon.",
    preview: "https://relievo.vercel.app/",
    code: "https://github.com/Namrata-J/relievo",
  },
  {
    title: "EOT",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661670609/mp/mp1.png",
    date: "Jul 8, 2022",
    techStack: "ReactJS, Redux, MaterialUI, Mockbee, ReactRouter",
    description:
      "EOT is a social media platform, a SPA application meant for the users to exchange and share thoughts.",
    preview: "https://eot-social-media.netlify.app/",
    code: "https://github.com/Namrata-J/EOT",
    features: "https://github.com/Namrata-J/EOT/tree/dev#features",
  },
  {
    title: "MusingStudio",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661751358/mp/mp7.png",
    date: "May 27, 2022",
    techStack: "ReactJS, VanillaCSS, ReactRouter, Toasts, Mockbee, Cloudinary",
    description:
      "A video library app providing list of songs and albums of different artists and categories.",
    preview: "https://musingstudio.netlify.app/",
    code: "https://github.com/Namrata-J/MusingStudio",
    features: "https://github.com/Namrata-J/MusingStudio/tree/dev#features",
  },
  {
    title: "TakeNotes",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661751147/mp/mp6.png",
    date: "Mar 31, 2022",
    techStack: "ReactJS, VanillaCSS, Typescript, Jest, ReactRouter, Mockbee",
    description:
      "A notes taking app to manage all your tasks and workflow in a better way.",
    preview: "https://tknotes.netlify.app/",
    code: "https://github.com/Namrata-J/TakeNotes",
    features: "https://github.com/Namrata-J/TakeNotes/tree/dev#features",
  },
  {
    title: "APRIZE",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661750960/mp/mp5.png",
    date: "Mar 14, 2022",
    techStack:
      "ReactJS, ExpeditechUI, VanillaCSS, Toasts, Mockbee, ReactRouter, Cloudinary",
    description:
      "An ecommerce store. Have used my own component library named Expeditech UI components to design it.",
    preview: "https://aprize-ecom-site.netlify.app/",
    code: "https://github.com/Namrata-J/APRIZE",
    features: "https://github.com/Namrata-J/APRIZE/tree/dev#features",
  },
  {
    title: "Expeditech-UI",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661750517/mp/mp4.png",
    date: "Jan 29, 2022",
    techStack: "HTML5, CSS3, VanillaJS",
    description:
      "A component library providing 10+ responsive components including 7+ functional components with previews. Also provides utility and reusable classes to ease the development process.",
    preview: "https://expeditech-ui.netlify.app/",
    code: "https://github.com/Namrata-J/Expeditech-UI",
    features: "https://github.com/Namrata-J/Expeditech-UI/tree/dev#features",
  },
];

export const miniProjectsList = [
  {
    title: "Framer motion Animations",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1752163516/mp__28.png",
    date: "Oct, 2023",
    techStack: "Framer motion",
    description:
      "A project containing few animations made using Framer motion library.",
    preview: "https://xjnx3j.csb.app/",
    code: "https://github.com/Namrata-J/Framer_motion_animations",
  },
  {
    title: "Drive Car",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1667755682/mp/mp_26.png",
    date: "Sep 26, 2022",
    techStack: "React Three Fiber",
    description:
      "A project based on metaverse made using React three fiber. Use arrow keys to drive the car, and press shift to speed up.",
    preview: "https://sz5x86.csb.app/",
    code: "https://github.com/Namrata-J/Drive_Car",
  },
  {
    title: "Where are my stockers!?",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1663816556/mp/mp-23.png",
    date: "Sep 11, 2021",
    techStack: "VanillaJs, HTML5, CSS3",
    description:
      "This app tells you the profit and loss you made in your stock purchase.",
    preview: "https://wherearemystockers.netlify.app/",
    code: "https://github.com/Namrata-J/Project-12",
  },
  {
    title: "Is your birthday a palindrome!?",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1663813106/mp/mp-22.png",
    date: "Sep 9, 2021",
    techStack: "VanillaJs, HTML5, CSS3",
    description:
      "This is fun app which tells you if your birthday is a palindrome and if not, then it also tells you the closest palindrome date.",
    preview: "https://isbirthdayapalindrome.netlify.app/",
    code: "https://github.com/Namrata-J/Project-11",
  },
  {
    title: "Fun With Triangles",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1663774566/mp/mp-21.png",
    date: "Sep 8, 2021",
    techStack: "VanillaJs, HTML5, CSS3",
    description:
      "Have fun with triangles. Interacting with this app wil let you know how fun it is to deal with triangles.",
    preview: "https://dofunwithtriangles.netlify.app/",
    code: "https://github.com/Namrata-J/Project-10",
  },
  {
    title: "Lucky Birthday!?",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1662144114/mp/m-p-15.png",
    date: "Sep 7, 2021",
    techStack: "VanillaJs, HTML5, CSS3",
    description:
      "This app checks if your birthday is lucky or not and is made using VanillaJs",
    preview: "https://dobcheck.netlify.app/",
    code: "https://github.com/Namrata-J/Is-your-birthday-lucky",
  },
  {
    title: "Cash Register Manager",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1662138266/mp/m-p14.png",
    date: "Sep 6, 2021",
    techStack: "VanillaJs, HTML5, CSS3",
    description:
      "This app tells you the minimum no. of notes that needs to be returned to the customer.",
    preview: "https://c-r-m.netlify.app/",
    code: "https://github.com/Namrata-J/Cash-Register-Manager",
  },
  {
    title: "Symphonize",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1663862065/mp/mp-25.png",
    date: "Sep 5, 2021",
    techStack: "ReactJs, HTML5, CSS3",
    description: "This is a music recommendation app.",
    preview: "https://xohzpc.csb.app/",
    code: "https://github.com/Namrata-J/Project-7",
  },
  {
    title: "C-A-S-E-S Interpreter",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1663821739/mp/mp-24.png",
    date: "Sep 1, 2021",
    techStack: "ReactJs, HTML5, CSS3",
    description:
      "This is an interpreter app made using ReactJs which interprets the emoji meaning.",
    preview: "https://nl7qc.csb.app/",
    code: "https://github.com/Namrata-J/Project-6",
  },
  {
    title: "Fun Translation App",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1663749654/mp/mp-20.png",
    date: "Aug 2, 2021",
    techStack: "VanillaJs, HTML5, CSS3",
    description:
      "A fun translation app made using VanillaJs.This app translates your text to fun-characters language.",
    preview: "https://funcartoontranslations.netlify.app/",
    code: "https://github.com/Namrata-J/Project-5",
  },
  {
    title: "Banana Talks",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1663685792/mp/mp_19.png",
    date: "Jul 27, 2021",
    techStack: "VanillaJs, HTML5, CSS3",
    description:
      "A banana talk app made using VanillaJs. It translates you english text into minions language.",
    preview: "https://minionbananatalks.netlify.app/",
    code: "https://github.com/Namrata-J/Project-4",
  },
  {
    title: "Awesome Landing Page",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661757475/mp/mp10.png",
    date: "Jul 16, 2021",
    techStack: "HTML5, CSS3",
    description:
      "Firms and organizations always wish to own a bussiness website for their firm. Have a look at this landing page.",
    preview: "https://njlandingpage.netlify.app/",
    code: "https://github.com/Namrata-J/Project-3",
  },
  {
    title: "Are you a Tvd fan?",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661757219/mp/mp9.png",
    date: "Apr 16, 2021",
    techStack: "NodeJs, Replit, CHALK",
    description:
      "Another NodeJs CLI app.I have used CHALK to enhance it.This shows that how big fan you are of Tvd series.",
    preview:
      "https://replit.com/@NamrataJain29/CLI-tvd-quiz?embed=1&output=1#index.js",
    code: "https://replit.com/@NamrataJain29/CLI-tvd-quiz#index.js",
  },
  {
    title: "How well do you know me?",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661756618/mp/mp8.png",
    date: "Apr 15, 2021",
    techStack: "NodeJs, Replit, CHALK",
    description:
      "A CLI app built with NodeJs.I have used CHALK to enhance it.You can send this to your friends and find out who really knows you.",
    preview:
      "https://replit.com/@NamrataJain29/CLI-quiz-app?embed=1&output=1#index.js",
    code: "https://replit.com/@NamrataJain29/CLI-quiz-app#index.js",
  },
];

export const portfoliosList = [
  {
    title: "Portfolio",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661836572/mp/mp-p.png",
    date: "Aug 27, 2022",
    techStack: "ReactJs, CSS3",
    description:
      "Portfolio made using ReactJs, to showcase all my projects, skills, blogs, etc.",
    preview: "https://namratajain.netlify.app/",
    code: "https://github.com/Namrata-J/my_portfolio",
  },
  {
    title: "Portfolio",
    img: "https://res.cloudinary.com/nj1508/image/upload/v1661671016/mp/mp3.png",
    date: "Jul 22, 2021",
    techStack: "HTML5, CSS3",
    description:
      "my portfolio where i have showcased all of my projects and works.",
    preview: "https://nj-portfolio.netlify.app",
    code: "https://github.com/Namrata-J/portfolio",
  },
];
